const bonusesTestIDs = {
  bonusesPage: 'bonuses-page',
  bonusesDatePickerButton: 'bonuses-date-picker-button',
  bonusesDatePickerSelectedDate: 'bonuses-date-picker-selected-date',
  bonusesTotalLabel: 'total-bonuses-label',
  bonusesTotalValue: 'total-bonuses-value',
  bonusTileColor: 'bonus-tile-color',
  bonusTileDescription: 'bonus-tile-description',
  bonusTileValue: 'bonus-tile-value',
  bonusesPieChart: 'bonuses-pie-chart',
  bonusesChartSelectedPercentage: 'chart-selected-bonus-percentage',
  bonusesChartSelectedDescription: 'chart-selected-bonus-description',
  bonusesChartDefaultText: 'chart-default-text',
  bonusesProgress: 'bonus-progress',
  bonusesProgressLabel: 'bonus-progress-label',
  periodMonthLabel: 'period-month-label',
  daysLeftLabel: 'period-days-left-label',
  newClientsPQVHeader: 'new-clients-pqv-header',
  bonusTier: 'bonus-tier-block',
  bonusTierHeader: 'bonus-tier-header',
  bonusSlotsRow: 'bonus-slots-row',
  bonusCompleteBadge: 'bonus-complete-badge',
  bonusTitle: 'bonus-title',
  bonusAmount: 'bonus-amount',
  earnedFcvValue: 'fcv-earned-value',
};

export default bonusesTestIDs;
